import React, { useState } from "react";
import { Link } from "react-router-dom";

const navLinks = [
  { name: "Home",       path: "/" },
  { name: "Services",   path: "/services" },
  { name: "Industries", path: "/industries" },
  { name: "AI Tools",   path: "/ai-tools" },
  { name: "Blog",       path: "/blog" },
  { name: "Careers",    path: "/careers" },
];

const socialLinks = [
  { name: "LinkedIn", url: "https://www.linkedin.com/company/metavixsolutions/" },
  { name: "X",        url: "https://x.com/MetaVix_ERP" },
];

function LinkedInIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
    </svg>
  );
}

function XIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
      <path d="M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.584-6.638 7.584H.474l8.6-9.83L0 1.154h7.594l5.243 6.932ZM17.61 20.644h2.039L6.486 3.24H4.298Z" />
    </svg>
  );
}

function SocialIcon({ name }) {
  if (name === "LinkedIn") return <LinkedInIcon />;
  if (name === "X") return <XIcon />;
  return null;
}

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  const linkStyle = {
    textDecoration: "none",
    color: "#374151",
    fontWeight: 500,
    fontSize: "16px",
  };

  const socialIconStyle = {
    color: "#6b7280",
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
  };

  const btnStyle = {
    backgroundColor: "#dc2626",
    color: "white",
    padding: "8px 20px",
    borderRadius: "8px",
    border: "none",
    cursor: "pointer",
    fontWeight: 500,
    marginLeft: "8px",
  };

  const mobileBtnStyle = {
    width: "100%",
    backgroundColor: "#dc2626",
    color: "white",
    padding: "10px 20px",
    borderRadius: "8px",
    border: "none",
    cursor: "pointer",
    fontWeight: 500,
    marginTop: "4px",
  };

  return (
    <header
      style={{
        position: "sticky",
        top: 0,
        zIndex: 50,
        width: "100%",
        // ── FIX: Use solid white background instead of rgba + blur
        // rgba + backdropFilter causes logo filter to render differently
        // on mobile browsers (Safari/Chrome iOS)
        backgroundColor: "#ffffff",
        boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
      }}
    >
      <div
        style={{
          maxWidth: "1280px",
          margin: "0 auto",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "12px 24px",
        }}
      >
        {/* ── LOGO + NAME ── */}
        <Link
          to="/"
          style={{ display: "flex", alignItems: "center", gap: "0px", textDecoration: "none" }}
        >
          {/*
            ── KEY FIX ──
            Removed the CSS `filter` property entirely.
            Instead we use android-chrome-192x192.png which already has
            the correct blue logo color — no filter tricks needed.
            This ensures consistent color on ALL browsers and devices.
          */}
          <img
            src={process.env.PUBLIC_URL + "/metavix-logo-transparent.png"}
            alt="MetaVix Solutions logo"
            style={{
              height: "74px",
              width: "74px",
              objectFit: "contain",
            }}
          />
          <span
            style={{
              fontSize: "22px",
              fontWeight: 700,
              background: "linear-gradient(to right, #1d4ed8, #3b82f6)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              marginLeft: "-12px",  // ← pulls text closer to logo
            }}
          >
            MetaVix Solutions
          </span>
        </Link>

        {/* ── DESKTOP NAV ── */}
        <nav
          className="desktop-nav"
          style={{ display: "flex", alignItems: "center", gap: "32px" }}
        >
          {navLinks.map((item, index) => (
            <Link key={index} to={item.path} style={linkStyle}>
              {item.name}
            </Link>
          ))}
        </nav>

        {/* ── DESKTOP RIGHT: Social + CTA ── */}
        <div
          className="desktop-right"
          style={{ display: "flex", alignItems: "center", gap: "12px" }}
        >
          {socialLinks.map((social) => (
            <a
              key={social.name}
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={social.name}
              style={socialIconStyle}
            >
              <SocialIcon name={social.name} />
            </a>
          ))}
          <Link to="/contact" style={{ textDecoration: "none" }}>
            <button style={btnStyle}>Get in Touch</button>
          </Link>
        </div>

        {/* ── HAMBURGER ── */}
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
          className="hamburger-btn"
          style={{
            display: "none",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            width: "36px",
            height: "36px",
            gap: "5px",
            background: "none",
            border: "none",
            cursor: "pointer",
          }}
        >
          <span style={{
            display: "block", width: "24px", height: "2px",
            backgroundColor: "#1f2937", transition: "all 0.3s",
            transform: menuOpen ? "rotate(45deg) translate(5px, 5px)" : "none",
          }} />
          <span style={{
            display: "block", width: "24px", height: "2px",
            backgroundColor: "#1f2937", transition: "all 0.3s",
            opacity: menuOpen ? 0 : 1,
          }} />
          <span style={{
            display: "block", width: "24px", height: "2px",
            backgroundColor: "#1f2937", transition: "all 0.3s",
            transform: menuOpen ? "rotate(-45deg) translate(5px, -5px)" : "none",
          }} />
        </button>
      </div>

      {/* ── MOBILE MENU ── */}
      <div
        className="mobile-menu"
        style={{
          overflow: "hidden",
          maxHeight: menuOpen ? "500px" : "0",
          opacity: menuOpen ? 1 : 0,
          transition: "max-height 0.3s ease, opacity 0.3s ease",
        }}
      >
        <nav
          style={{
            display: "flex",
            flexDirection: "column",
            padding: "8px 24px 20px",
            gap: "16px",
            fontWeight: 500,
            backgroundColor: "#ffffff",
            borderTop: "1px solid #f3f4f6",
          }}
        >
          {navLinks.map((item, index) => (
            <Link
              key={index}
              to={item.path}
              style={linkStyle}
              onClick={() => setMenuOpen(false)}
            >
              {item.name}
            </Link>
          ))}

          <div style={{ display: "flex", gap: "16px", paddingTop: "4px" }}>
            {socialLinks.map((social) => (
              <a
                key={social.name}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={social.name}
                style={socialIconStyle}
                onClick={() => setMenuOpen(false)}
              >
                <SocialIcon name={social.name} />
              </a>
            ))}
          </div>

          <Link
            to="/contact"
            style={{ textDecoration: "none" }}
            onClick={() => setMenuOpen(false)}
          >
            <button style={mobileBtnStyle}>Get in Touch</button>
          </Link>
        </nav>
      </div>

      <style>{`
        @media (max-width: 768px) {
          .desktop-nav   { display: none !important; }
          .desktop-right { display: none !important; }
          .hamburger-btn { display: flex !important; }
        }
        @media (min-width: 769px) {
          .mobile-menu { display: none !important; }
        }
      `}</style>
    </header>
  );
}

export default Navbar;